// src/pages/DedicatedRequestsPage.jsx
import React, { useEffect, useState, useMemo } from "react";
import {
    Box,
    Heading,
    Text,
    TextInput,
    Spinner,
    Button,
} from "grommet";
import { Search } from "grommet-icons";
import axios from "axios";
import { HeaderNavigation } from "../../components/Headers/PursuitHeader";
import { StickyFooter } from "../../components/Footers/GlobalFooter";
import BreadcrumbNavigation from "../../components/AdminPortal/BreadcrumbNavigation";
import DedicatedRequestsTable from "../../components/PursuitAccess/DedicatedRequestsTable";
import { parseDelivery } from "../../components/PursuitAccess/DedicatedRequestsTable";

const DedicatedRequestsPage = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const { data } = await axios.get(
                    "/api/pursuit/get-dedicated-requests"
                );
                setRequests(data.learning_details || []);
            } catch {
                setError("Failed to load dedicated learning requests.");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    // simple text filter on name/email
    const filtered = useMemo(() => {
        const lower = (searchValue || "").toLowerCase().trim();
        if (!lower) return requests;

        return requests.filter((r) => {
            const nameMatch = (r.name || "")
                .toLowerCase()
                .includes(lower);
            const emailMatch = (r.learning_email || "")
                .toLowerCase()
                .includes(lower);
            const countryMatch = (r.learning_country || "")
                .toLowerCase()
                .includes(lower);


            return (
                nameMatch || emailMatch || countryMatch
            );
        });
    }, [requests, searchValue]);

    return (
        <Box fill="vertical" background="light-2">
            <HeaderNavigation />
            <BreadcrumbNavigation
                breadcrumbs={[
                    { label: "Dashboard", link: "/pursuit/dashboard" },
                    {
                        label: "Dedicated Learning Requests",
                        link: "/pursuit/dedicated-requests",
                    },
                ]}
            />
            <Box height="2px" background="brand" margin={{ vertical: "small" }} />

            {/* Container with vertical gap */}
            <Box
                flex
                pad={{ horizontal: "medium", vertical: "small" }}
                gap="medium"           // ← ensure spacing
                overflow="auto"
            >
                {/* ─── Header & Filter Section ─── */}
                <Box gap="small">
                    <Box direction="row" align="center" justify="between">
                        <Heading level={2} margin="none">
                            Dedicated Learning Requests
                        </Heading>
                    </Box>
                    <Text>
                        Here you can review all dedicated learning requests.
                    </Text>
                    <Box width="300px">
                        <TextInput
                            icon={<Search />}
                            placeholder="Search by name, country or email…"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                        />
                    </Box>
                </Box>

                {/* ─── Table Section ─── */}
                <Box flex overflow={{ horizontal: "auto" }}>
                    {loading ? (
                        <Box fill align="center" justify="center">
                            <Spinner size="large" />
                        </Box>
                    ) : error ? (
                        <Text color="status-critical">{error}</Text>
                    ) : (
                        <DedicatedRequestsTable requests={filtered} />
                    )}
                </Box>
            </Box>

            <StickyFooter />
        </Box>
    );
};

export default DedicatedRequestsPage;
